import { styled } from "@vitality-ds/system";
import BaseCloseIconButtonStyles from "./styles/BaseCloseIconButton.styles";

// eslint-disable-next-line import/prefer-default-export
export var BaseCloseIconButton = styled("button", BaseCloseIconButtonStyles);